import { SvgIcon, SvgIconProps } from "@mui/material";

export const JavascriptIcon = ({ ...props }: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 18 18" {...props}>
			<g clip-path="url(#clip0_7739_11965)" fill="none">
				<path d="M18 0H0V17.7143H18V0Z" fill="#F7DF1E" />
				<path
					d="M12.0922 13.8398C12.4548 14.4224 12.9265 14.8506 13.7608 14.8506C14.4617 14.8506 14.9094 14.5059 14.9094 14.0296C14.9094 13.4588 14.4494 13.2566 13.6779 12.9246L13.2551 12.746C12.0345 12.2343 11.2237 11.5932 11.2237 10.2379C11.2237 8.98945 12.1902 8.03906 13.7008 8.03906C14.7762 8.03906 15.5494 8.40741 16.1065 9.37185L14.7894 10.2041C14.4994 9.6924 14.1865 9.49079 13.7008 9.49079C13.2054 9.49079 12.8914 9.80009 12.8914 10.2041C12.8914 10.7035 13.2057 10.9057 13.9314 11.215L14.3542 11.3932C15.7914 11.9998 16.6028 12.6181 16.6028 14.0082C16.6028 15.5069 15.4065 16.3279 13.7999 16.3279C12.2291 16.3279 11.2142 15.5913 10.7177 14.6257L12.0922 13.8398ZM6.11709 13.984C6.38281 14.448 6.62452 14.8402 7.20566 14.8402C7.76138 14.8402 8.11195 14.6262 8.11195 13.7942V8.1341H9.80338V13.8167C9.80338 15.5404 8.77652 16.3248 7.27766 16.3248C5.92338 16.3248 5.13909 15.6351 4.74023 14.8044L6.11709 13.984Z"
					fill="black"
				/>
			</g>
			<defs>
				<clipPath id="clip0_7739_11965">
					<rect width="18" height="17.7143" fill="white" />
				</clipPath>
			</defs>
		</SvgIcon>
	);
};
